import styles from './ProfileInitials.module.scss';

interface IProfileInitials {
  firstName?: string;
  lastName?: string;
  size?: number;
}

const ProfileInitials = (props: IProfileInitials) => {
  const { firstName, lastName, size } = props;

  if (!firstName && !lastName) return null;

  const firstInitial = props.firstName?.charAt(0).toUpperCase() || '';
  const lastInitial = props.lastName?.charAt(0).toUpperCase() || '';
  const initials = firstInitial + lastInitial;
  const sizeStyle = size ? { width: `${size}px`, height: `${size}px` } : {};

  return (
    <div className={styles['profile-initials']} style={sizeStyle}>
      {initials}
    </div>
  );
};

export default ProfileInitials;
